module.exports = __webpack_public_path__ + "static/media/mailnews_23.86614276.ico";